<script lang="ts">
	import { onMount } from "svelte";
	import LoginForm from "../Components/LoginForm/LoginForm.svelte";
	import Session from "../Models/Session";

	const sessionToken = Session.getToken();
	
	onMount(() => {
		if (sessionToken) window.location.replace('/#/dashboard');
	})
</script>

<section class="loginView">
	<LoginForm />
</section>

<style type="text/scss">
	.loginView {
		background-color: #f45b69;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		min-height: 100vh;
	}
</style>